module.exports = __webpack_public_path__ + "static/img/viral_24.b755b66a.jpg";